module.exports = __webpack_public_path__ + "static/2front-ux-2-9a70b334f8b50a7f01c03a23045a3989.png";